import getCombatantFilterIndexById from './getCombatantFilterIndexById'
//-----------------------------
// set local combatants extras
//-----------------------------
export default function setLocalCombatantsExtras(combatants, extra_combatants) {
  console.log("-----------------------")
  console.log("IN setLocalCombatantsExtras")
  for (let i = 0; i < combatants.length; i++) {
    combatants[i].extra = false
  }

  for (let i = 0; i < extra_combatants.length; i++) {
    let idx = getCombatantFilterIndexById(combatants, extra_combatants[i].id)
    combatants[idx].extra = true
  }
  return combatants
}
